import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    testigos: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_TESTIGOS = 'GET_ALL_TESTIGOS'
const GET_TESTIGOS_BY_ID = 'GET_TESTIGOS_BY_ID'
const POST_TESTIGOS = 'POST_TESTIGOS'
const POST_TESTIGOS_INE = 'POST_TESTIGOS_INE'
const UPDATE_TESTIGOS = 'UPDATE_TESTIGOS'
const DELETE_TESTIGOS = 'DELETE_TESTIGOS'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllTestigos = createAsyncThunk(
    GET_ALL_TESTIGOS,
    async () => {
        try {
            const fullUrl = host + `Fi25Testigos/obtenerTestigos`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Vehiculos: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getTestigosById = createAsyncThunk(
    GET_TESTIGOS_BY_ID,
    async (idTestigo) => {
        try {
            const fullUrl = host + `Fi25Testigos/obtenerTestigoById/${idTestigo}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertTestigosIne = createAsyncThunk(
    POST_TESTIGOS_INE,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Testigos/agregarTestigoConIne`
            //alert(JSON.stringify(data))
            const datamain = { data: data.data }
            const imagen = data.imagen
            const imagen2 = data.imagen2
            let formData = new FormData();
            formData.append(0, imagen)
            formData.append(1, imagen2)
            formData.append('idfi_25caratula', datamain.data.idfi_25caratula)
            formData.append('nombre', datamain.data.nombre)
            const resFile = await axios.post(fullUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return 'result'
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertTestigos = createAsyncThunk(
    POST_TESTIGOS,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Testigos/agregarTestigo`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateTestigos = createAsyncThunk(
    UPDATE_TESTIGOS,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Testigos/actualizarTestigo`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteTestigos = createAsyncThunk(
    DELETE_TESTIGOS,
    async (idTestigo) => {
        try {
            const fullUrl = host + `Fi25Testigos/eliminarTestigo/${idTestigo}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosTestigosSlice = createSlice({

    name: 'metodosTestigosSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllTestigos.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.testigos = payload.data.data

        },
        [getTestigosById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.testigos = payload.data.data
        },
        [insertTestigos.fulfilled]: (state, { payload }) => {
        },
        [insertTestigosIne.fulfilled]: (state, { payload }) => {
        },
        [updateTestigos.fulfilled]: (state, { payload }) => {

        },
        [deleteTestigos.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosTestigosSlice.actions
export const TestigosReducer = metodosTestigosSlice.reducer